import { render, staticRenderFns } from "./DetailGudangKompack.vue?vue&type=template&id=766fa770&scoped=true&"
import script from "./DetailGudangKompack.vue?vue&type=script&lang=js&"
export * from "./DetailGudangKompack.vue?vue&type=script&lang=js&"
import style0 from "./DetailGudangKompack.vue?vue&type=style&index=0&id=766fa770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766fa770",
  null
  
)

export default component.exports